import { render, staticRenderFns } from "./DownloadModal.vue?vue&type=template&id=7018aa1d&scoped=true&"
import script from "./DownloadModal.vue?vue&type=script&lang=js&"
export * from "./DownloadModal.vue?vue&type=script&lang=js&"
import style0 from "./DownloadModal.vue?vue&type=style&index=0&id=7018aa1d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7018aa1d",
  null
  
)

export default component.exports